export const BUTTON_DATE_PICKER_TEST_ID = 'ButtonDatePicker';
export const INPUT_DATE_PICKER_DATA_TEST_ID = 'InputDatePicker';
export const TIME_PICKER_INPUT_GROUP_DATA_TEST_ID = 'TimePickerInputGroup';
export const DEFAULT_MIN_DATE = new Date('2011-01-01T00:00:00');
